export type ParsedCuzkAddress = {
  ulice: string | null
  castObce: string | null
  psc: string | null
  obec: string | null
}

export function parseCuzkAddress(adresa: string): ParsedCuzkAddress {
  try {
    const parts = adresa.split(', ')
    if (parts.length < 2 || parts.length > 3) {
      throw new Error('Neočekávaný počet částí')
    }

    const ulice = parts[0] || null
    let castObce: string | null = null
    let pscObec = ''

    if (parts.length === 3) {
      castObce = parts[1] || null
      pscObec = parts[2]
    } else {
      /* length = 2 */
      pscObec = parts[1]
    }

    const firstSpace = pscObec.indexOf(' ')
    if (firstSpace === -1) {
      throw new Error('Nelze rozdělit PSČ a obec')
    }

    const psc = pscObec.slice(0, firstSpace) || null
    const obec = pscObec.slice(firstSpace + 1) || null

    return { ulice, castObce, psc, obec }
  } catch {
    return { ulice: null, castObce: null, psc: null, obec: null }
  }
}
